// extracted by mini-css-extract-plugin
export default {"MultiPropertiesEditor__FieldContainer":"MultiPropertiesEditor_MultiPropertiesEditor__FieldContainer__Ose3D"};